import * as React from 'react';
import './DashboardView.scss';
import DashboardMenu from './components/DashboardMenu';
import DashboardContent from './components/DashboardContent';
import ECheckPaymentDetailsMobile from './components/ManageECheck/ECheckPaymentDetailMobile';
import CreditsPaymentDetailsMobile from './components/ManageCredits/CreditsPaymentDetailMobile';
import EcheckPaymentModel from 'src/model/echeckPayment.model';
import CreditModel from 'src/model/credit.model';

interface IDashboardViewProps {
  isPending: boolean;
  getUserDetails(): void;
}

interface IDashboardViewState {
  showSlideMenu: boolean;
  selectedPayment: EcheckPaymentModel;
  selectedCredit: CreditModel;
}

export class DashboardView extends React.Component<
  IDashboardViewProps,
  IDashboardViewState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      showSlideMenu: false,
      selectedPayment: null,
      selectedCredit: null
    };
  }

  public componentDidMount() {
    this.props.getUserDetails();
  }

  private handleCreditDetails = (credit: any) => {
    this.setState({
      selectedCredit: credit,
      showSlideMenu: true
    });
  };

  private handlePaymentDetails = (payment: any) => {
    this.setState({
      selectedPayment: payment,
      showSlideMenu: true
    });
  };

  private handleCloseSlide = () => {
    this.setState({
      showSlideMenu: false,
      selectedPayment: null,
      selectedCredit: null
    });
  };

  public render() {
    return (
      <div className="rp-dashboard-view">
        {!this.state.showSlideMenu ? (
          <React.Fragment>
            <div className="page-title">My Dashboard</div>

            <div className="container-fluid rp-dashboard-view--container">
              <div className="row">
                <div className="col-md-3 rp-dashboard-view--menu">
                  <DashboardMenu />
                </div>
                <div className="col-md-9 rp-dashboard-view--content">
                  <DashboardContent
                    selectedPayment={this.state.selectedPayment}
                    selectedCredit={this.state.selectedCredit}
                    handleCreditDetails={this.handleCreditDetails}
                    handlePaymentDetails={this.handlePaymentDetails}
                  />
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {this.state.selectedPayment && (
              <ECheckPaymentDetailsMobile
                showSlideMenu={this.state.showSlideMenu}
                onCloseSlide={this.handleCloseSlide}
                paymentDetails={this.state.selectedPayment}
              />
            )}
            {this.state.selectedCredit && (
              <CreditsPaymentDetailsMobile
                showSlideMenu={this.state.showSlideMenu}
                onCloseSlide={this.handleCloseSlide}
                creditDetails={this.state.selectedCredit}
              />
            )}
          </React.Fragment>
        )}
      </div>
    );
  }
}
